import { useEffect, useRef, useState } from 'react';
import { getViralLinkIframeSrc } from '../utils/urls';
import { onIframeResizeMessage } from '../utils/postMessageUtils';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledIframe = styled.iframe.withConfig({
  displayName: "EmbeddedViralLink__StyledIframe",
  componentId: "sc-7swm6y-0"
})(({
  iframeHeight
}) => {
  return {
    width: '100%',
    border: 'none',
    height: `${iframeHeight || 0}px`
  };
});
export default function EmbeddedViralLink({
  langOverride,
  linkType,
  portalId,
  additionalParams
}) {
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState();
  useEffect(() => {
    onIframeResizeMessage({
      iframeRef,
      onMessage: value => {
        setIframeHeight(parseInt(value, 10));
      }
    });
  }, [iframeRef]);
  return /*#__PURE__*/_jsx(StyledIframe, {
    iframeHeight: iframeHeight,
    "aria-label": `hubspot-${linkType}-viral-iframe`,
    "data-test-id": "viral-link-iframe",
    ref: iframeRef,
    src: getViralLinkIframeSrc(linkType, Object.assign({
      lang: langOverride,
      portalId
    }, additionalParams))
  });
}